import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class PlanService {

  constructor(private httpService: HttpService) { }


  DefaultStep(data:any) {
    const url = `${environment.PlanApiendpoint}/plan-in-visit`;
    return this.httpService.get(url,this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
  }

  firstStep(data:any) {
    const url = `${environment.PlanApiendpoint}/make-plan`;
    return this.httpService.post(url,data, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
  }



  secondStep(id:any) {
    const url = `${environment.PlanApiendpoint}/phlebo-plan-view/${id}`;
    return this.httpService.get(url,this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
  }


    thirdStep(id:any) {
    const url = `${environment.PlanApiendpoint}/make-final-plan`;
    return this.httpService.post(url,id,this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
  }
    fourthStep (id:any) {
    const url = `${environment.PlanApiendpoint}/final-visit-update`;
    return this.httpService.put(url,id,this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
  }

  changephlebo(data:any) {
    const url = `${environment.PlanApiendpoint}/final-update`;
    return this.httpService.put(url,data,this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
  }

  updatePhleboPlan(data:any){
    const url = `${environment.PlanApiendpoint}/update-phlebo-plan`;
    return this.httpService.put(url,data,this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
  }

  updateVisitPlan(data:any){
    const url = `${environment.PlanApiendpoint}/update-visit-latlong`;
    return this.httpService.put(url,data,this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
  }

  deletephleboPlan(id:any){
    const url = `${environment.PlanApiendpoint}/phlebo-plan-delete/${id}`;
    return this.httpService.get(url,this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
  }
  Errorhandling(err: HttpErrorResponse) {
    if (err.error instanceof ErrorEvent) {
        console.error(err.error.message);
    } else {
        console.error(`Backend returned code ${err.status}`);
    }
    return throwError('Please try again later.');
  }
}
